





















import Vue from "vue";
import moment from "moment";
import { mapGetters } from "vuex";

export default Vue.extend({
    data() {
        return { moment };
    },
    props: ["installationBranchMovingList"],
    computed: {
        ...mapGetters(["userDateFormat", "longDateFormat"]),
        shortDateFormat() {
            return this.userDateFormat.replace("MM", "MMMM").replace(/-/g, " ");
        },
    },
});
